import { Element } from "react-scroll";

// Components
import Header from "../components/Header";
import Hero from "../components/Hero";
import QRSection from "../components/QRSection";
import AchievementsAndVolunteer from "../components/AchievementsAndVolunteer";
import Footer from "../components/Footer";

function HomePage() {
  const sections = [
    { name: "home", component: <Hero /> },
    { name: "download", component: <QRSection /> },
    { name: "achievements-volunteer", component: <AchievementsAndVolunteer /> },
    { name: "contact", component: <Footer /> },
  ];

  return (
    <div className="font-qomra">
      <Header />

      {sections.map(({ name, component }) => (
        <Element key={name} name={name}>
          <div>
            {component}
          </div>
        </Element>
      ))}
    </div>
  );
}


export default HomePage;
